import React, { useEffect, useState } from "react";
import "./uploadDocument.css";
import { Field, Form, Formik } from "formik";
import logoutimg from "../../../assets/logout.png";
import uploadDoc from "../../../assets/uploadDoc.svg";
import reupload from "../../../assets/reUpload.svg";
import * as Yup from "yup";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uploadDrugLicence } from "../../../redux/actions/onBordingActions";
import { Spinner } from "react-bootstrap";
import { logout } from "../../../redux/actions/authActions";
import { Document, Page, pdfjs } from "react-pdf";
import SkipModal from "../../../components/modals/skipModal";
import ErrorPopup from "../../../components/Popups/ErrorPopup";
import SuccessPopup from "../../../components/Popups/SuccessPopUp";
import { pdfChecker } from "../../../components/utilites/helper";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const UploadDocumentDrugLicense = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [skipShow, setSkipShow] = useState(false);
  const [img1, setImg1] = useState(null);
  const [img2, setImg2] = useState(null);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");
  const [loadImgFnc, setloadImgFnc] = useState(false);

  useEffect(() => {
    if (
      img1 != null &&
      img1.trim() != "" &&
      img2 !== null &&
      img2.trim() != ""
    ) {
      setDisable(false);
    } else {
      setDisable(true);
    }
    if (loadImgFnc) {
      imageUpdateOne();
    }
  }, [img1, img2, loadImgFnc]);

  const imageUpdateOne = (file) => {
    console.log(file.target.files[0]);
    // data for submit
    setLoading(true);
    dispatch(
      uploadDrugLicence(
        file.target.files[0],
        onImage1UploadSuccess,
        onImage1UploadError
      )
    );
    // setImages(imageList);
  };

  const onImage1UploadSuccess = (data) => {
    setLoading(false);
    setImg1(data.data.data.filePath);
  };

  const onImage1UploadError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    setShowErrorMsg(err?.data?.message + ", Please Upload Proper Image/PDF");
    setTimeout(closeErrorPopup, 2000);
  };

  const imageUpdateSecond = (file) => {
    console.log(file.target.files[0]);
    // data for submit
    setLoading(true);
    if (file.target.files[0]) {
      dispatch(
        uploadDrugLicence(
          file.target.files[0],
          onImage2UploadSuccess,
          onImage2UploadError
        )
      );
    }
    // setImageSecond(imageList);
  };

  const onImage2UploadSuccess = (data) => {
    console.log(data);
    setLoading(false);
    setImg2(data.data.data.filePath);
  };

  const onImage2UploadError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    setShowErrorMsg(err?.data?.message + ", Please Upload Proper Image/PDF");
    setTimeout(closeErrorPopup, 2000);
  };

  const initialValues = {
    drug_licence_certificate_20_a: "",
    drug_licence_certificate_20_b: "",
  };
  const loginSchema = Yup.object().shape({
    // profileImage: Yup.mixed().required("Upload an Image"),
  });
  const onSubmit = (values, { resetForm }) => {
    // resetForm();
    console.log(values, location.state, img1, img2);
    let dispatchData = location.state;
    dispatchData["drug_licence_certificate_20_a"] = img1;
    dispatchData["drug_licence_certificate_20_b"] = img2;
    console.log(dispatchData);
    navigate("/upload-document-gst", {
      state: dispatchData,
    });
  };

  const skipFnc = (values) => {
    console.log(values, location.state, img1, img2);
    let dispatchData = location.state;
    dispatchData["drug_licence_certificate_20_a"] = null;
    dispatchData["drug_licence_certificate_20_b"] = null;
    console.log(dispatchData);
    navigate("/upload-document-gst", {
      state: dispatchData,
    });
  };

  const [file, setFile] = useState();

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/login");
  };
  const logoutSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const message = data.data.message;
    const msg_updated = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const logoutError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <div className="upload-main-container d-flex justify-content-center align-items-center ">
      <div className="upload-form-container w-100 mx-4">
        <div className="d-flex justify-content-between px-3  mx-sm-2 mt-3">
          <div className="ms-3">
            <label className="fw_500 fn_Nunito fs_20 fs_md_18 fs_sm_16">
              Upload Documents
            </label>
          </div>
          <div
            className="d-flex align-items-center  mb-md-3 cursor_pointer"
            onClick={() => logoutHandler()}
          >
            <span className="fs_12 fw_600 color_2ad3e7 ">Logout</span>
            <img className="mx-1" src={logoutimg} height="12px" />
          </div>
        </div>
        <div className=" px-2 mx-1 px-sm-3 mx-sm-2 ">
          <p className="fs_12 fs_sm_10 col-9 col-sm-6 fn_Nunito color_b0b3c7 ms-3 ">
            Kindly provide your Drug License pictures with us.
          </p>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={loginSchema}
        >
          {({ formik, values, setFieldValue }) => {
            return (
              <Form className="">
                <div className="mt-4">
                  <div className="row mt-3">
                    <div className="col-lg-6 col-md-8 col-12 mx-auto ">
                      <div className="mx-4 ps-lg-3 my-2">
                        <div
                          className="d-flex justify-content-between align-items-end"
                          style={{ maxWidth: "450px" }}
                        >
                          <label className="fs_14">Drug License 1</label>
                          {img1 !== "" && img1 !== null && (
                            <>
                              <label
                                htmlFor="DrugLicense1"
                                style={{ textTransform: "uppercase" }}
                                className="fs_12 me-2 Medium_Purple fw_700 align-items-center"
                              >
                                <img src={reupload} className="mb-1" />{" "}
                                Re-UPload
                              </label>
                            </>
                          )}
                        </div>
                        <input
                          type="file"
                          name="upload"
                          id="DrugLicense1"
                          accept="application/pdf,image/png,image/jpeg"
                          style={{ display: "none" }}
                          onChange={imageUpdateOne}
                        />

                        {img1 !== "" && img1 !== null ? (
                          <div
                            className={` h-100`}
                            style={{
                              height: "25rem",
                              overflowY: "scroll",
                              overflowX: "hidden",
                              scrollBehavior: "smooth",
                            }}
                          >
                            <>
                              {pdfChecker(img1) ? (
                                <div className="doc-upload-container">
                                  <Document file={img1}>
                                    <Page pageNumber={1} width={415} />
                                  </Document>
                                </div>
                              ) : (
                                <div
                                  className="doc-upload-container"
                                  style={{ position: "relative" }}
                                >
                                  <img
                                    style={{ width: "100%", height: "100%" }}
                                    src={img1}
                                  />
                                </div>
                              )}
                            </>
                          </div>
                        ) : (
                          <>
                            <label
                              htmlFor="DrugLicense1"
                              className="w-100"
                              // style={{ width: "500px" }}
                            >
                              <div className="doc-upload-container w-100 text-center">
                                <img
                                  src={uploadDoc}
                                  alt="doc"
                                  className="mt-5"
                                />
                                <p className="Medium_Purple fw_700 my-1 fs_17">
                                  Choose File
                                </p>
                                <p className="color_b0b3c7 fs_12">
                                  Supports: PDF and Image files
                                </p>
                              </div>
                            </label>
                            <input
                              type="file"
                              name="upload"
                              id="DrugLicense1"
                              accept="application/pdf,image/png,image/jpeg"
                              style={{ display: "none" }}
                              onChange={imageUpdateOne}
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-8 col-12 mx-auto ">
                      <div className="mx-4 pe-lg-3 my-2">
                        <div
                          className="d-flex justify-content-between align-items-end"
                          style={{ maxWidth: "450px" }}
                        >
                          <label className="fs_14">Drug License 2</label>
                          {img2 !== "" && img2 !== null && (
                            <>
                              <label
                                htmlFor="GSTCertificate"
                                style={{ textTransform: "uppercase" }}
                                className="fs_12 me-2 Medium_Purple fw_700 align-items-center"
                              >
                                <img src={reupload} className="mb-1" />{" "}
                                Re-UPload
                              </label>
                            </>
                          )}
                        </div>
                        <input
                          type="file"
                          name="upload"
                          id="GSTCertificate"
                          accept="application/pdf,image/png,image/jpeg"
                          style={{ display: "none" }}
                          onChange={imageUpdateSecond}
                        />

                        {img2 !== "" && img2 !== null ? (
                          <div
                            className={` h-100`}
                            style={{
                              height: "25rem",
                              overflowY: "scroll",
                              overflowX: "hidden",
                              scrollBehavior: "smooth",
                            }}
                          >
                            <>
                              {pdfChecker(img2) ? (
                                <div className="doc-upload-container">
                                  <Document file={img2}>
                                    <Page pageNumber={1} width={415} />
                                  </Document>
                                </div>
                              ) : (
                                <div
                                  className="doc-upload-container"
                                  style={{ position: "relative" }}
                                >
                                  <img
                                    style={{ width: "100%", height: "100%" }}
                                    src={img2}
                                  />
                                </div>
                              )}
                            </>
                          </div>
                        ) : (
                          <>
                            <label htmlFor="DrugLicense" className="w-100">
                              <div className="doc-upload-container w-100 text-center">
                                <img
                                  src={uploadDoc}
                                  alt="doc"
                                  className="mt-5"
                                />
                                <p className="Medium_Purple fw_700 my-1 fs_17">
                                  Choose File
                                </p>
                                <p className="color_b0b3c7 fs_12">
                                  Supports: PDF and Image files
                                </p>
                              </div>
                            </label>
                            <input
                              type="file"
                              name="upload"
                              id="DrugLicense"
                              accept="application/pdf,image/png,image/jpeg"
                              onChange={imageUpdateSecond}
                              style={{ display: "none" }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center justify-content-lg-end  px-lg-4 mx-lg-2 me-lg-3 my-4 py-2">
                    <button
                      className="upload-skip-button col-12 mx-3"
                      type="button"
                      onClick={() => setSkipShow(true)}
                      // disabled={disable}
                    >
                      SKIP
                    </button>
                    <button
                      className="upload-next-button col-12"
                      type="submit"
                      disabled={disable}
                    >
                      {loading && <Spinner size="sm" />}
                      Next
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
        <SkipModal
          titel="Drug License Documents"
          show={skipShow}
          handleClose={() => setSkipShow(false)}
          skipFnc={skipFnc}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
        <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      </div>
    </div>
  );
};

export default UploadDocumentDrugLicense;
